/*
 * @Date: 2026-03-16 09:35:03
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2026-06-01 17:25:37
 */
// ─── 路由路径 ─────────────────────────────────────────────────────────────────

export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGIN_SUCCESS = '/login-success';
export const ROUTE_TELE_MONITORING = '/tele-monitoring';
export const ROUTE_VOICE_CALL = '/voice-call';

/** 不需要登录鉴权的公开页面路径列表 */
export const PUBLIC_ROUTES: string[] = [ROUTE_LOGIN, ROUTE_LOGIN_SUCCESS];
